/**
 * GroundTruth Event Listeners
 *
 * Uses the unified event system (pmw:pixel:*) with firing decisions.
 *
 * @see https://help.groundtruth.com/hc/en-us/articles/43656481694483-Install-GroundTruth-Pixel-Manually
 */

(function (pmw, undefined) {

	/**
	 * Load pixel on consent
	 */
	pmw.bus.on("pmw:load-pixels", function () {
		if (
			pmwDataLayer?.pixels?.groundtruth?.gtid &&
			!pmwDataLayer?.pixels?.groundtruth?.loaded &&
			pmw.consent.canPixelBeFired("marketing", "GroundTruth")
		) {
			pmw.loadGroundTruthPixel();
		}
	});

	/**
	 * Add to Cart event
	 *
	 * Fires when a product is added to the cart.
	 */
	pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {
		if (!pmwDataLayer?.pixels?.groundtruth?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "groundtruth")) return;

		try {
			const groundTruthData = payload.pixels?.groundtruth;
			if (!groundTruthData) return;

			pmw.groundTruthTrackEvent(groundTruthData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Purchase / Order Received event
	 *
	 * Fires when a purchase is completed and the order received page is viewed.
	 */
	pmw.bus.on("pmw:pixel:purchase", (payload) => {
		if (!pmwDataLayer?.pixels?.groundtruth?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "groundtruth")) return;

		try {
			const groundTruthData = payload.pixels?.groundtruth;
			if (!groundTruthData) return;

			pmw.groundTruthTrackEvent(groundTruthData);
		} catch (e) {
			console.error(e);
		}
	});

}(window.pmw = window.pmw || {}));
